const DEFAULT_COLOR_RGB = '#ffffff'

export { DEFAULT_COLOR_RGB }

export default DEFAULT_COLOR_RGB
